
import {
  defineComponent, ref, watch, onUnmounted, onMounted,
} from 'vue';
import moment from 'moment';
import { Select, } from 'ant-design-vue';
import * as echarts from 'echarts';
import { postRequest, } from '@/request/request';

const { Option, } = Select;

export default defineComponent({
  components: {
    Select,
    Option,
  },
  props: {
    theme: {
      type: String,
      default: '',
      requir: true,
    },
    popupData: {
      type: Object,
      default: () => ({}),
      requir: true,
    },
  },
  setup (props, { emit, }) {
    const cookingFumeData = ref<any>({});
    const mnNos = ref<string[]>([]);
    const monTime = ref<string>('');
    let chart: any = null;

    // 请求返回的历史数据
    let historyData: any = [];
    // 当前选中的指标-折线图显示内容
    const checked = ref<string>('density');

    // 所选当前设备id
    const defaultValue = ref<string>('');

    // 设备状态
    const equLists = {
      purifyStatus: '净化器',
      monitorStatus: '监测仪',
      particleStatus: '风机',
    };
    // 指标状态
    const indexLists = {
      density: {
        lable: '油烟',
        icon: 'icon-youyanji01',
      },
      particleCon: {
        lable: '颗粒物',
        icon: 'icon-chengshixikeliwu',
      },
      noMethHydrocabon: {
        lable: '非甲烷总烃',
        icon: 'icon-jzjc5-copy',
      },
    };

    const option = {
      tooltip: {
        trigger: 'axis',
      },
      grid: {
        y: '20px',
        x: '50px',
        // 高度
        height: '62%',
      },
      xAxis: {
        // 隐藏刻度线
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: '#000',
            fontSize: '12',
          },
        },
        data: [],
      },
      yAxis: {
        type: 'value',
        // 隐藏y轴
        axisLine: {
          show: false,
        },
        // 隐藏刻度线
        axisTick: {
          show: false,
        },
        //  网格线设置
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#000',
            opacity: '0.3',
          },
        },
        axisLabel: {
          show: true,
          textStyle: {
            fontSize: '12',
            color: '#000',
          },
        },
      },
      visualMap: {
        show: false,
        pieces: [
          {
            lte: 0,
            color: 'blue',
          },
          {
            gt: 0,
            lte: 1,
            color: '#f4ea2a',
          },
          {
            gt: 1,
            color: '#d81e06',
          },
        ],
        outOfRange: {
          color: '#999',
        },
      },
      series: {
        type: 'line',
        showSymbol: false,
        data: [],
        // data: data.map((item:any) => item.density),
      },
    };

    const changeRankingVisable = () => {
      emit('close');
    };

    const queryBaseInfo = (params: any) => postRequest('/gaochun/airMap/cookingFumeInfo', params);
    const queryChartInfo = (params: any) => postRequest('/gaochun/airMap/cookingFumeHistory', params);

    const reSize = (): any => {
      if (chart) {
        chart.resize();
      }
    };
    const initCharts = () => {
      const container = document.getElementById('cooking-chart') as HTMLElement;

      chart = echarts.init(container);
      window.addEventListener('resize', reSize);
    };

    // 绘制柱状图
    const setChart = (val: any) => {
      option.xAxis.data = historyData.map((item: any) => moment(item.dataTime, 'YYYYMMDDHH').format('HH'));
      option.series.data = historyData.map((item: any) => item[val]);

      setTimeout(() => {
        if (chart && val) {
          chart.setOption(option);
        }
      }, 300);
    };

    const handleHistoryChange = (val: string) => {
      if (checked.value === val) {
        return;
      }
      checked.value = val;

      setChart(val);
    };

    const init = async (mnNo: string, currentTime: string) => {
      const paramsBase = {
        mnNo,
      };

      // 请求基础数据
      const res = await queryBaseInfo(paramsBase);
      const BaseInfo: any = res.data || {};
      const { dataTime, } = BaseInfo;

      // 展示数据
      cookingFumeData.value = BaseInfo;
      monTime.value = currentTime || dataTime;

      // 无监控时间则不请求折线图数据
      if (!monTime.value) {
        historyData = [];
        setChart(checked.value);

        return;
      }

      const paramsChart = {
        mnNo,
        endTime: moment(monTime.value, 'YYYYMMDDHHmm').format('YYYYMMDDHHmmss'),
        startTime: moment(monTime.value, 'YYYYMMDDHHmm')
          .subtract(24, 'hours')
          .format('YYYYMMDDHHmmss'),
      };

      // 请求折线图数据
      const resTmp = await queryChartInfo(paramsChart);

      historyData = resTmp.data || [];
      setChart(checked.value);
    };

    const handleChange = async (mnNo: any) => {
      const paramsChart = {
        mnNo,
        endTime: moment(monTime.value, 'YYYYMMDDHHmm').format('YYYYMMDDHHmmss'),
        startTime: moment(monTime.value, 'YYYYMMDDHHmm')
          .subtract(24, 'hours')
          .format('YYYYMMDDHHmmss'),
      };

      // 请求折线图数据
      const resTmp = await queryChartInfo(paramsChart);

      historyData = resTmp.data || [];
      setChart(checked.value);
    };

    watch(
      () => props.popupData,
      (cur) => {
        if (Object.keys(cur).length) {
          mnNos.value = cur.mnNos || [];
          defaultValue.value = cur.mnNos[0] || '';
          checked.value = 'density';
          historyData = [];

          init(defaultValue.value, cur.currentTime);
        }
      },
      { immediate: true, }
    );

    onMounted(() => {
      initCharts();
    });

    onUnmounted(() => {
      window.removeEventListener('resize', reSize);
      echarts.dispose(chart);
      chart = null;
    });

    return {
      moment,
      equLists,
      indexLists,
      cookingFumeData,
      mnNos,
      monTime,
      defaultValue,
      checked,
      handleHistoryChange,
      handleChange,
      changeRankingVisable,
    };
  },
});
